import { Dispatch, SetStateAction, useCallback } from 'react'
import { DefaultStockType } from 'types/schedule'

const useDefaultStockCallback = (update: Dispatch<SetStateAction<DefaultStockType[]>>) => {
  return useCallback(
    (value: DefaultStockType, index: number) => {
      update((prevState) => {
        const nextState = prevState
        nextState[index] = value
        return [...nextState]
      })
    },
    [update]
  )
}

export default useDefaultStockCallback
